function sintomas(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"Os sintomas mais comuns são: tosse, dor de garganta, febre, coriza, dificuldade para respirar ou falta de ar, perda de olfato, alteração do paladar.",
						"title":"Quais os sintomas da doença?",
						"image":"images/games/informs/sintomas/1.png",
					},
					{
						"text":"Náusea, vômito, diarreia, cansaço e falta de apetite, também são sintomas comuns para a COVID-19.",
						"title":"Quais os sintomas da doença?",
						"image":"images/games/informs/sintomas/1.png",
					},
					{
						"text":"Em quadros mais leves da doença os sintomas podem ser análogos aos de um resfriado comum.",
						"title":"Quais os sintomas da doença?",
						"image":"images/games/informs/sintomas/1.png",
					},
					{
						"text":"Por isso recomenda-se 14 dias de isolamento social para pessoas que apresentam sintomas da síndrome gripal.",
						"title":"Quais os sintomas da doença?",
						"image":"images/games/informs/sintomas/1.png",
					},
					{
						"text":"Em casos mais graves, que apresentam os sintomas de falta de ar ou dificuldade para respirar, a indicação é procurar atendimento médico/hospitalar.",
						"title":"Quais os sintomas da doença?",
						"image":"images/games/informs/sintomas/1.png",
					},
					{
						"text":"Aproximadamente 20% das pessoas infectadas podem desenvolver esse quadro da doença.",
						"title":"Quais os sintomas da doença?",
						"image":"images/games/informs/sintomas/1.png",
					},
					{
						"text":"A maioria das pessoas que testam positivo para COVID-19 podem ser assintomáticas (que não apresentam sintomas), ou  que apresentam sintomas leves.",
						"title":"Quais os sintomas da doença?",
						"image":"images/games/informs/sintomas/1.png",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/sintomas/1.png"
			}
		]
	};
}

export {sintomas};
